import { render, staticRenderFns } from "./overflowTooltip.vue?vue&type=template&id=21ffe8fe&scoped=true"
import script from "./overflowTooltip.vue?vue&type=script&lang=js"
export * from "./overflowTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ffe8fe",
  null
  
)

export default component.exports